import React, { Component } from "react";
import Modal from "../../components/UI/Modal/Modal";
import Aux from "../Aux/Aux";

const withErrorHandler = (WrappedComponent, axios) => {
  return class extends Component {
    state = {
      error: false,
      showBackdrop: false,
    };
    componentDidMount() {
      this.reqInterceptor = axios.interceptors.request.use((req) => {
        this.setState({ error: false });
        return req;
      });
      this.resInterceptor = axios.interceptors.response.use(
        (res) => res,
        (error) => {
          this.setState({ error: error });
          this.setState({ showBackdrop: !this.state.showBackdrop });
        }
      );
    }
    componentWillUnmount() {
      axios.interceptors.request.eject(this.reqInterceptor);
      axios.interceptors.response.eject(this.resInterceptor);
    }

    errorConfirmedHandler = () => {
      this.setState({ showBackdrop: !this.state.showBackdrop });
      this.setState({ error: false });
    };

    toggleBackdrop = () => {
      this.setState({ showBackdrop: !this.state.showBackdrop });
    };
    render() {
      return (
        <Aux>
          <Modal
            show={this.state.showBackdrop}
            hideBackdrop={this.toggleBackdrop}
            clicked={this.errorConfirmedHandler}
          >
            {this.state.error ? this.state.error.message : null}
          </Modal>
          <WrappedComponent {...this.props} />
        </Aux>
      );
    }
  };
};

export default withErrorHandler;
